import { motion } from "framer-motion";
import ScrollReveal from "./scroll-reveal";

const processSteps = [
  {
    id: 1,
    title: "Consultation",
    description: "We understand your workspace needs and design preferences through detailed consultation.",
    icon: "fas fa-comments",
    color: "bg-blue-500"
  },
  {
    id: 2,
    title: "Design & Planning",
    description: "Our experts create customized furniture solutions tailored to your space and requirements.",
    icon: "fas fa-drafting-compass",
    color: "bg-green-500"
  },
  {
    id: 3,
    title: "Manufacturing",
    description: "Premium quality furniture crafted with attention to detail using sustainable materials.",
    icon: "fas fa-hammer",
    color: "bg-orange-500"
  },
  {
    id: 4,
    title: "Delivery & Installation",
    description: "Professional delivery and installation service ensuring perfect setup in your workspace.",
    icon: "fas fa-truck",
    color: "bg-purple-500"
  }
];

export default function ProcessSection() {
  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4">
              Our Process
            </h2>
            <p className="text-xl text-neutral max-w-2xl mx-auto">
              From concept to completion, we ensure a seamless experience
            </p>
          </div>
        </ScrollReveal>

        <div className="relative">
          {/* Process Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-green-500 via-orange-500 to-purple-500 transform -translate-y-1/2"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {processSteps.map((step, index) => (
              <ScrollReveal key={step.id} delay={index * 0.2}>
                <motion.div
                  className="text-center relative"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  {/* Step Number */}
                  <motion.div
                    className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-6 text-white font-bold text-xl relative z-10`}
                    whileHover={{ rotate: 360 }}
                    transition={{ duration: 0.6 }}
                  >
                    {step.id}
                  </motion.div>

                  {/* Icon */}
                  <motion.div
                    className="w-12 h-12 bg-accent rounded-full flex items-center justify-center mx-auto mb-4"
                    whileHover={{ scale: 1.2 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={`${step.icon} text-white text-lg`}></i>
                  </motion.div>

                  <h3 className="text-xl font-semibold mb-3 text-primary dark:text-white">
                    {step.title}
                  </h3>
                  <p className="text-neutral dark:text-gray-300 leading-relaxed">
                    {step.description}
                  </p>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}